export default __webpack_public_path__ + "static/media/arkivet-logo.8c9f5224.svg";